<template>
  <div class="Landing-Holder bg-[#0E171F] min-h-screen flex flex-col items-center justify-center text-white">
    <!-- Titre principal -->
    <h1 class="text-[#FFB701] text-3xl md:text-6xl mt-2 md:mt-6 font-bold font-alize animate-fade-in">
      Let Me Wax You
    </h1>

    <!-- Date et lieu -->
    <p class="text-[#FFB701] text-2xl md:text-3xl mt-2">{{ $t('landing.date') }}</p>
    <p class="text-[#FFB701] text-3xl md:text-4xl font-alize">PARIS</p>

    <!-- Conteneur principal -->
    <div class="w-11/12 md:w-7/12 bg-[#950C16] rounded-lg p-6 mt-6 shadow-xl animate-slide-up">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <!-- Image de gauche -->
        <div class="bg-cover bg-top md:bg-center h-80 md:h-96 rounded-lg shadow-md transition-transform hover:scale-105"
          :style="{ backgroundImage: `url(${left})` }"></div>

        <!-- Vidéo au centre (format TikTok 9:16) -->
        <div class="flex w-full  justify-center rounded-lg overflow-hidden items-center">
          <video controls muted
            class="h-[500px] w-full  md:w-[280px] rounded-lg shadow-lg transition-transform hover:scale-105">
            <source src="/video.mp4#t=0.5" type="video/mp4" />
          </video>
        </div>

        <!-- Image de droite -->
        <div class="bg-cover bg-top md:bg-center h-80 md:h-96 rounded-lg shadow-md transition-transform hover:scale-105"
          :style="{ backgroundImage: `url(${right})` }"></div>
      </div>
    </div>



    <!-- Description événement -->
    <div class="text-center text-md md:text-xl font-light mt-6 px-6 max-w-3xl animate-fade-in ">
      <p class=" whitespace-pre-line space-y-4">{{ $t('landing.body') }}</p>
    </div>

    <!-- Texte au-dessus du compteur -->
    <div class="text-center text-[#e6204b] text-xl md:text-2xl font-light mb-6 tracking-wide mt-10">
      {{ $t('landing.count.before') }}
    </div>

    <!-- Compte à rebours stylisé Apple-like -->
    <div class="flex justify-center space-x-2 md:space-x-10 text-2xl md:text-5xl font-semibold text-[#FFB701] ">

      <!-- Jours -->
      <div class="flex flex-col items-center">
        <span class="leading-tight">{{ String(decompte.d).padStart(2, '0') }}</span>
        <p class="text-xs text-gray-300 mt-2 uppercase tracking-widest">{{ $t('landing.count.day') }}</p>
      </div>
      <span class="text-white">:</span>

      <!-- Heures -->
      <div class="flex flex-col items-center">
        <span class="leading-tight">{{ String(decompte.h).padStart(2, '0') }}</span>
        <p class="text-xs text-gray-300 mt-2 uppercase tracking-widest">{{ $t('landing.count.hr') }}</p>
      </div>
      <span class="text-white">:</span>

      <!-- Minutes -->
      <div class="flex flex-col items-center">
        <span class="leading-tight">{{ String(decompte.mn).padStart(2, '0') }}</span>
        <p class="text-xs text-gray-300 mt-2 uppercase tracking-widest">{{ $t('landing.count.mn') }}</p>
      </div>
      <span class="text-white">:</span>

      <!-- Secondes -->
      <div class="flex flex-col items-center">
        <span class="leading-tight">{{ String(decompte.sc).padStart(2, '0') }}</span>
        <p class="text-xs text-gray-300 mt-2 uppercase tracking-widest">{{ $t('landing.count.sc') }}</p>
      </div>
    </div>

    <!-- Texte après -->
    <div class="text-center text-white text-xl md:text-2xl font-light my-6 tracking-wide ">
      {{ $t('landing.count.after') }}
    </div>

    <!-- Bouton CTA -->
    <div class="mt-10">
      <router-link to="/tickets"
        class="bg-[#e6204b] text-white px-5 md:px-8 py-2 md:py-3 rounded-full text-sm md:text-lg shadow-lg hover:bg-[#950C16] transition-transform hover:scale-110">
        {{ $t('reservermaintenant') }}
      </router-link>
    </div>

    <!-- FAQ -->
    <div class="mt-10 w-11/12 md:w-7/12 bg-[#1E2A35] rounded-lg p-6 shadow-xl">
      <h2 class="text-[#FFB701] text-2xl md:text-3xl font-bold text-center">FAQ</h2>
      <p class="mt-4 text-md md:text-lg">❓ {{ $t('quelleestlatenue') }} ? <br> 🔹 {{ $t('chicettechnique') }}</p>
      <p class="mt-4 text-md md:text-lg">❓ {{ $t('ouacheterlesbillets') }} ? <br> 🔹 {{ $t('surnotresite') }}</p>
      <p class="mt-4 text-md md:text-lg">❓ {{ $t('yatilundresscode') }} ? <br> 🔹 {{ $t('ouiprivilegiezlewax') }}</p>
    </div>

    <!-- Logo -->
    <div class="mt-6">
      <img :src="Icon" alt="logo" class="w-32">
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import left from './left.jpg';
import Icon from './logo_text_white.png';
import right from './right.jpg';

export default {
  setup() {
    const eventDate = new Date('2025-12-06T20:30:00');

    const getCount = () => {
      const now = new Date();
      const diff = eventDate.getTime() - now.getTime();

      const sc = Math.floor((diff / 1000) % 60);
      const mn = Math.floor((diff / (1000 * 60)) % 60);
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));

      return { d, h, mn, sc };
    };
    const decompte = ref(getCount());
    onMounted(() => {
      const interval = setInterval(() => {
        decompte.value = getCount();
      }, 1000);
      return () => clearInterval(interval);
    });

    return { decompte, Icon, left, right };
  },


};
</script>



<style scoped>
.animate-fade-in {
  animation: fade-in 1.2s ease-out;
}

.animate-slide-up {
  animation: slide-up 1s ease-out;
}


.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 165, 0, 0.5);
  /* Couleur orange semi-transparente */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Animation pour l'overlay */
.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.5s ease-out;
}

.overlay-enter,
.overlay-leave-to

/* .overlay-leave-active in <2.1.8 */
  {
  opacity: 0;
}
</style>
